loggerService.$inject = [];

export default function loggerService() {
  class LoggerService {
    errorMessage(resp) { //eslint-disable-line
      let error = 'An error has occurred. Please try again or contact hello@tablelist.com for support.';

      if (resp && resp.message) {
        error = resp.message;
      } else if (resp && resp.errors && resp.errors[0] && resp.errors[0].message) {
        error = resp.errors[0].message;
      } else if (resp && resp.data && resp.data.errors && resp.data.errors[0] && resp.data.errors[0].message) {
        error = resp.data.errors[0].message;
      }

      return error;
    }
  }

  return new LoggerService();
}



// WEBPACK FOOTER //
// ./src/services/utilsService.js